/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { Svg, GProps, Path } from 'react-native-svg';
import { getIconColor } from './helper';

interface Props extends GProps, ViewProps {
  size?: number;
  color?: string | string[];
}

let BrowsingHistoryO: FunctionComponent<Props> = ({ size, color, ...rest }) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} {...rest}>
      <Path
        d="M512 910.222336c219.931648 0 398.222336-178.290688 398.222336-398.222336 0-219.931648-178.290688-398.222336-398.222336-398.222336-219.931648 0-398.222336 178.290688-398.222336 398.222336 0 219.931648 178.290688 398.222336 398.222336 398.222336z m0 56.88832C260.64896 967.110656 56.889344 763.35104 56.889344 512S260.64896 56.889344 512 56.889344 967.110656 260.64896 967.110656 512 763.35104 967.110656 512 967.110656z"
        fill={getIconColor(color, 0, '#333333')}
      />
      <Path
        d="M512.002048 341.332992c191.970304 0 284.442624 162.7136 284.442624 170.667008 0 7.962624-90.001408 170.667008-284.442624 170.667008-194.444288 0-284.44672-162.70336-284.44672-170.667008 0-7.954432 92.47232-170.667008 284.44672-170.667008z m0 56.889344c-69.479424 0-128.171008 25.307136-176.523264 68.073472-16.616448 14.696448-30.906368 30.595072-42.176512 45.97248 11.021312 15.251456 25.028608 30.99648 41.388032 45.561856 47.92832 42.67008 106.744832 67.94752 177.311744 67.94752 70.565888 0 129.381376-25.27744 177.307648-67.94752 16.360448-14.565376 30.36672-30.3104 41.388032-45.561856-11.270144-15.377408-25.55904-31.276032-42.175488-45.97248-48.352256-42.766336-107.041792-68.073472-176.520192-68.073472zM512 455.110656c31.418368 0 56.889344 25.470976 56.889344 56.889344S543.418368 568.889344 512 568.889344 455.110656 543.418368 455.110656 512s25.470976-56.889344 56.889344-56.889344z"
        fill={getIconColor(color, 1, '#333333')}
      />
    </Svg>
  );
};

BrowsingHistoryO.defaultProps = {
  size: 18,
};

BrowsingHistoryO = React.memo ? React.memo(BrowsingHistoryO) : BrowsingHistoryO;

export default BrowsingHistoryO;
